<template>
    <div class="process pl32 Disp_AC">
        <span class="close el-icon-close" @click="$emit('close')"></span>
        <div class="mr16">
            <cl-svg-icon
                class="mr4"
                width="40"
                height="54"
                :currentColor="false"
                :icon-class="`tu_file_${$utils.formatSuffix(fileData.name)}`"
            ></cl-svg-icon>
        </div>
        <div style="flex:1;">
            <p class="mb8">
                <span>{{ fileData.name }}</span>
                <span
                    class="ml32"
                    v-html="$t('schedule.文件大小', { size: fileData.size })"
                ></span>
                <span
                    class="ml32"
                    v-html="
                        $t('schedule.下载进度', {
                            process: fileData.progressBar,
                        })
                    "
                ></span>
            </p>
            <el-progress
                style="width:100%;"
                :percentage="fileData.progressBar"
                :show-text="false"
            ></el-progress>
        </div>
    </div>
</template>

<script>
/**
 * ComponentName: 单个进度条组件
 * Created Date:2022/5/21
 * Author: Nancy
 * 组件说明：
 * eg:
 *     <cl-process-bar></cl-process-bar>
 */
export default {
    name: 'cl-process-bar',
    data() {
        return {};
    },

    props: ['fileData'],

    methods: {},
};
</script>
<style lang="scss" scoped>
/deep/.el-progress-bar__inner {
    background: linear-gradient(180deg, #37b7ac 0%, #65b168 100%);
    border-radius: 10px;
}
.process {
    position: fixed;
    bottom: 10px;
    // right: 24px;
    left: 70px;
    right: 0;
    margin: auto;
    background: #ffffff;
    box-shadow: 0px 5px 20px rgba(120, 120, 133, 0.3);
    border-radius: 10px;
    height: 84px;
    width: 1164px;
    box-sizing: border-box;
    z-index: 2009;
    padding-right: 146px;
    .close {
        position: absolute;
        top: 12px;
        right: 12px;
        color:  #B7B7BF;
        background-color: rgba(54, 99, 225, 0);
        cursor: pointer;
        padding: 6px;
        border-radius: 6px;
        font-size: 20px;
        &:hover{
            color : #3663E1;
            background-color: rgba(54, 99, 225, 0.08);
        }
    }
}
</style>
